// extracted by mini-css-extract-plugin
export default {"container":"CertificationList_container__kFcQC","container__open":"CertificationList_container__open__Fh8TA","container__closed":"CertificationList_container__closed__2yojL"};